import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import nl from "./locales/nl.json";
import de from "./locales/de.json";
import ar from "./locales/ar.json";
import arExtra from "./locales/ar-extra.json";
import arPages from "./locales/ar-pages.json";
import arAssets from "./locales/ar-assets.json";
import arRelated from "./locales/ar-related.json";
import fr from "./locales/fr.json";
import frExtra from "./locales/fr-extra.json";
import frPages from "./locales/fr-pages.json";
import frAssets from "./locales/fr-assets.json";
import es from "./locales/es.json";
import esExtra from "./locales/es-extra.json";
import esPages from "./locales/es-pages.json";
import esAssets from "./locales/es-assets.json";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English", dir: "ltr" },
  { code: "nl", label: "Dutch", native: "Nederlands", dir: "ltr" },
  { code: "de", label: "German", native: "Deutsch", dir: "ltr" },
  { code: "ar", label: "Arabic", native: "العربية", dir: "rtl" },
  { code: "fr", label: "French", native: "Français", dir: "ltr" },
  { code: "es", label: "Spanish", native: "Español", dir: "ltr" },
];

export const dirFor = (code) =>
  LANGUAGES.find((l) => l.code === code)?.dir || "ltr";

const composeTranslation = (base, ...extras) => {
  const localizedContent = Object.assign({}, ...extras.map((extra) => extra.localizedContent || {}));
  return { ...base, ...Object.assign({}, ...extras), localizedContent };
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
      de: { translation: de },
      ar: { translation: composeTranslation(ar, arExtra, arPages, arAssets, arRelated) },
      fr: { translation: composeTranslation(fr, frExtra, frPages, frAssets) },
      es: { translation: composeTranslation(es, esExtra, esPages, esAssets) },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "nl", "de", "ar", "fr", "es"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "marketlume_lang",
    },
  });

const applyDir = (lng) => {
  const dir = dirFor(lng);
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
};

applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
